module.exports = "/_next/static/images/DataScienceModeling-60fec2d43c65d7c79b0bb6c650a7f1ba.png";